export function isIos() {
	
	const IOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	
	if ( IOS ) {
		$("body").addClass("is-ios");
	}
}


// WEBPACK FOOTER //
// ./assets/js/modules/is-ios.js